<template>
  <!--联系我们页面-->
  <tk-container class="b-g-f" :status="status" @refresh="getInit">
    <!--头部-->
    <my-header slot="header">联系我们</my-header>
    <!--内容-->
    <card v-if="contactUs" :height="500" :width="100" class="p-12">
      <div v-html="contactUs"></div>
    </card>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      contactUs: null // 联系我们内容
    }
  },
  computed: {},
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.getInit()
  },
  methods: {
    async getInit () {
      try {
        this.setStatusBar('dark')
        let res = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/contactUs').catch(e => {
          return { data: null }
        })
        if (res.data) { this.contactUs = res.data } else { this.contactUs = null }
        if (!this.contactUs) {
          this.status = 'empty'
          return
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep img {
  width: 100%;
}
</style>
